///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import SimpleCell from "./SimpleCell";

export const TagCell = ({ value, cellDetails, ...rest }) => {
  const label = cellDetails.tagLabel.find(x => x.value === value)?.label;

  return (
    <SimpleCell cellDetails={cellDetails} {...rest}>
      <span className={`tag-cell ${label ? "" : "background-transparent"}`}>
        {label}
      </span>
    </SimpleCell>
  );
};

export default TagCell;
